import { Link } from '@tanstack/react-router';
import { fmtDateTime, scoreText, STATUS_LABEL, statusPill } from '../lib/format';
import type { MatchRow } from '../lib/types';
import { Badge } from './badges';

export function StatusPill({ m }: { m: Pick<MatchRow, 'status' | 'periodStartedAt'> }) {
  return <span className={statusPill(m.status)}>{liveLabel(m)}</span>;
}

/** "63'" while live, from the start of the current period. */
export function liveLabel(m: Pick<MatchRow, 'status' | 'periodStartedAt'>): string {
  if (!m.periodStartedAt || !['FIRST_HALF', 'SECOND_HALF', 'EXTRA_TIME'].includes(m.status)) return STATUS_LABEL[m.status];
  const mins = Math.max(1, Math.floor((Date.now() - new Date(m.periodStartedAt).getTime()) / 60_000) + 1);
  const base = m.status === 'FIRST_HALF' ? 0 : m.status === 'SECOND_HALF' ? 45 : 90;
  const cap = m.status === 'EXTRA_TIME' ? 30 : 45;
  return mins > cap ? `${base + cap}+${mins - cap}'` : `${base + mins}'`;
}

export function Fixture({ m, link = true }: { m: MatchRow; link?: boolean }) {
  const inner = (
    <div className="row" style={{ flexWrap: 'nowrap', gap: 12 }}>
      <div className="teams" style={{ flex: 1, justifyContent: 'flex-end' }}>
        <span className="name">{m.homeName}</span>
        <Badge spec={m.homeBadge} size={22} />
      </div>
      <span className="score" style={{ minWidth: 54, textAlign: 'center' }}>
        {scoreText(m)}
      </span>
      <div className="teams" style={{ flex: 1 }}>
        <Badge spec={m.awayBadge} size={22} />
        <span className="name">{m.awayName}</span>
      </div>
    </div>
  );
  return link ? (
    <Link to="/matches/$matchId" params={{ matchId: String(m.id) }} style={{ color: 'inherit', textDecoration: 'none' }}>
      {inner}
    </Link>
  ) : (
    inner
  );
}

export function MatchFlags({ m }: { m: MatchRow }) {
  return (
    <span className="row" style={{ gap: 4 }}>
      {!m.published && <span className="pill">Draft</span>}
      {!m.kickoffConfirmed && <span className="pill pill-amber">Time TBC</span>}
      {m.lockOverridden && <span className="pill pill-amber">Lock set by hand</span>}
      {m.feedFrozen && <span className="pill pill-amber">Feed frozen</span>}
      {m.settledAt && <span className="pill pill-green">Confirmed</span>}
      {m.revision !== m.scoredRevision && <span className="pill pill-red">Scoring behind</span>}
    </span>
  );
}

export function KickoffCell({ m }: { m: MatchRow }) {
  return <span className="num">{fmtDateTime(m.kickoffAt)}</span>;
}
